import { render, staticRenderFns } from "./RoomEdit.vue?vue&type=template&id=bb13e0fc&scoped=true&lang=pug"
import script from "./RoomEdit.vue?vue&type=script&lang=ts"
export * from "./RoomEdit.vue?vue&type=script&lang=ts"
import style0 from "./RoomEdit.vue?vue&type=style&index=0&id=bb13e0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb13e0fc",
  null
  
)

export default component.exports